import { render, staticRenderFns } from "./comDeclare.vue?vue&type=template&id=d69a1c76"
import script from "./comDeclare.vue?vue&type=script&lang=js"
export * from "./comDeclare.vue?vue&type=script&lang=js"
import style0 from "./comDeclare.vue?vue&type=style&index=0&id=d69a1c76&prod&scropd=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports